import { combineReducers } from 'redux'
import merge from 'lodash/merge'
import { RECEIVE_SUBSIDIARIES, RECEIVE_SUBSIDIARY } from '../actions/subsidiary-actions'

const all = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_SUBSIDIARIES: return merge([], action.subsidiaries)
    default: return state
  }
}

const detail = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_SUBSIDIARY: return action.subsidiary
    default: return state
  }
}

export default combineReducers({
  all,
  detail
})
